import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root'
})
export class OzonSettingsValidator {

    client_id = [
        Validators.required
    ];

    apikey = [
        Validators.required
    ];

    // Error messages
    errorMessages = {
        clinet_id: [
            {
                type: 'required',
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        apikey: [
            {
                type: 'required',
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ]
    }
}